var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJdbc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M113.3,105.9c65.2,0,110.7-16.5,110.7-36.9V46.9c0-20.4-45.5-36.9-110.7-36.9C48.1,10,10,26.5,10,46.9V69C10,89.4,48.1,105.9,113.3,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M99.9,194.1c-44.8-1.7-70.9-11.9-84.7-25.6c-3.5,3.5-5.2,7.2-5.2,11.1v29.5c0,20.4,38.1,36.9,103.3,36.9c6.5,0,12.9-0.2,19.1-0.5C115.6,233.5,103.7,215.3,99.9,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M98.5,179.3c0.1-19.5,7-37.4,18.6-51.3c-1.4,0-2.7,0-4.2,0c-52.9,0-82.6-10.9-97.7-25.8c-3.5,3.5-5.2,7.2-5.2,11.1v29.5C10,161.5,42.4,177,98.5,179.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M114.7,165.9c6.3-5.6,16.1-11.2,30.1-11.2c19.8,0,29.3,10.5,37.6,19.9c7.7,8.6,14.4,16,28.5,16c19,0,32.5-11.5,35.1-13.8c-1.5-35.3-30.6-63.5-66.3-63.5C147.7,113.3,121.1,135.8,114.7,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M175.5,180.8c-8.1-9-15.1-16.8-30.6-16.8c-22.1,0-30.9,17.5-31,17.6l-0.5-0.2c1,35.8,30.3,64.6,66.4,64.6c33.5,0,61.2-24.8,65.7-57c-7.3,4.9-19.3,10.9-34.5,10.9C192.6,199.9,183.5,189.8,175.5,180.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdbc);
export default __webpack_public_path__ + "static/media/jdbc.e3c377c41f60307a486ce098d457341e.svg";
export { ForwardRef as ReactComponent };